import { FC, useContext } from "react";
import "./ProductionPlan.scss";
import Layout from "../components/layout/Layout";
import { useLocation, Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const ProductionPlan: FC<{}> = () => {

    const { hasPermission } = useContext(AuthContext);
    const location = useLocation();

    if (!hasPermission("ViewProductionPlan")) {
        return <Navigate to="/" replace state={{ from: location }} />
    }

    return (
        <Layout className='productionplan'>
            <iframe className="airtable-embed" src="https://airtable.com/embed/appWMgo2TrAOhjveX/shriCz6u1Umdbv5xX?viewControls=on" title="plan" frameBorder="0" width="100%" height="533" style={{background: 'transparent', border: '1px solid #ccc'}}></iframe>
        </Layout>
    )
}

export default ProductionPlan;